
<template>
<div>
  <coming-soon-modal :dialog.sync="dialog"></coming-soon-modal>
  <v-bottom-nav
    v-if="show"
    class = "bottomNavbar"
    :active.sync="bottomNav"
    :value="true"
  >
    <v-btn 
      color="primary"
      flat
      value="dashboard"
      @click="replace('/dashboard')"
    >
      <span>Inicio</span>
      <v-icon>home</v-icon>
    </v-btn>

    <v-btn
      color="primary"
      flat
      value="equipments"
      @click="replace('/equipments')"
    >
      <span>Equipos</span>
      <v-icon>track_changes</v-icon>
    </v-btn>
    <v-bottom-sheet v-model="sheet" >
      <v-btn @click="trackMas()"
        flat
        color="primary"
        value="mas"
        slot="activator"
      >
        <span>Mas</span>
        <v-icon>menu</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile @click="selectedSettings()">
          <v-list-tile-avatar>
            <v-avatar size="32px" tile>
              <v-icon>settings</v-icon>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title>Ajustes</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="commignsoon('/historics')">
          <v-list-tile-avatar>
            <v-avatar size="32px" tile>
              <v-icon>history</v-icon>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title>Históricos</v-list-tile-title>
        </v-list-tile>
        <v-list-tile  @click="onLogout()">
          <v-list-tile-avatar>
            <v-avatar size="32px" tile>
              <v-icon>exit_to_app</v-icon>
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-title>Cerrar sesión</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </v-bottom-nav>
</div>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        show: true,
        bottomNav: '',
        sheet: false
      };
    },
    watch: {
      '$route' (to, from) {
        to = to.fullPath;
        this.show = true;
        if (['/dashboard', '/equipments'].includes(to)) {
          this.bottomNav = to.slice(1);
        } else if (to === '/deviceDetail') {
          this.bottomNav = 'equipments';
        } else if (['/historics', '/settings'].includes(to)) {
          this.bottomNav = 'mas';
        } else if (['/', '/deviceCreation', '/signup', '/signup2', '/signin', '/newOrganization'].includes(to)) {
          this.show = false;
        }
      }
    },
    created () {
      const currentPath = this.$route.path;
      if (['/dashboard', '/equipments'].includes(currentPath)) {
        this.bottomNav = currentPath.slice(1);
      } else if (['/historics', '/settings'].includes(currentPath)) {
        this.bottomNav = 'mas';
      } else if (['/', '/deviceCreation', '/signup', '/signup2', '/signin', '/newOrganization'].includes(currentPath)) {
        this.show = false;
      }
    },
    methods: {
      commignsoon () {
        this.dialog = true;
      },
      replace (path) {
        if (path !== '/settings') {
          this.$router.replace(path);
        }
      },
      selectedSettings () {
        this.$router.replace('/userInfo');
        this.sheet = false;
      },
      trackMas () {
        mixpanel.track('Click Mas');
        gtag('event', 'click_mas', {event_category: 'click', event_label: 'Click Mas'});
      },
      onLogout () {
        mixpanel.track('Sign out');
        gtag('event', 'sign_out', {event_category: 'click', event_label: 'Sign out'});
        localStorage.setItem('auth_token', '');
        this.$store.dispatch('logout');
        this.$router.push('/');
        this.sheet = false;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// BottomNav.vue?056f87e6